import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * A back button that returns to the page the user came from, or to a fallback
 * when the app was opened on this page (a fresh tab, a shared link).
 *
 * @param fallbackPath - Where to go when there is no earlier page in the app
 * @returns Whether there is an earlier page, and the handler that goes back
 */
export function useBackNavigation(fallbackPath: string) {
  const navigate = useNavigate();
  // React Router gives the entry the app first loaded on the key "default".
  const canGoBack = useLocation().key !== 'default';

  const goBack = useCallback(() => {
    if (canGoBack) navigate(-1);
    else navigate(fallbackPath);
  }, [canGoBack, fallbackPath, navigate]);

  return { canGoBack, goBack };
}
